import { useEffect, useRef } from "react";
import { animate } from "framer-motion";
import { useAnimation } from "../lib/AnimationContext";

/**
 * A span that does a quick scale "pop" whenever its value changes (not on first render).
 * Animates the existing node instead of remounting it, so rapid taps never drop or delay a value.
 * @param {{value: *, className?: string, noPop?: boolean}} props
 *   noPop: skip the animation (e.g. for live-ticking timer values that change every few ms)
 */
export default function PopValue({ value, className, noPop = false }) {
    const { preset } = useAnimation();
    const ref = useRef(null);
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!preset || noPop || !ref.current) return;
        const el = ref.current;
        const controls = animate(el, { scale: [preset.pop.scale, 1] }, { duration: preset.pop.duration, ease: "easeOut" });
        return () => {
            controls.stop();
            el.style.transform = "";
        };
    }, [value, preset, noPop]);

    return <span ref={ref} className={className}>{value}</span>;
}
